$(document).ready(function () {
    $(document).on("focus", '#identificationVM_Login', function (e) {
        //autocompleteEmail($(this));
    });

    $(document).on("focus", '#Login', function (e) {
        //autocompleteEmail($(this));
    });

    function autocompleteEmail(zoneSaisie) {
        // todo : tester si ws ok
        //if ($('#CodePaysAlpha3').val() != null && $('#CodePaysAlpha3').val().length > 0) {
        if (!zoneSaisie.data("autocomplete")) {
            zoneSaisie.autocomplete({
                source: function (request, response) {
                    $.post("/Espaceclient/SuggestEmail", { email: zoneSaisie.val() }, function (data) {
                        if (data.Data != null && data.Data.length > 0) {
                            response($.map(data.Data, function (item) {
                                return {
                                    label: item.Email,
                                    value: item.Email
                                };
                            }));
                        } else {
                            if (data.Message != null && data.Message.length > 0) {
                                zoneSaisie.addClass("input-validation-error");
                                zoneSaisie.next('.field-validation-error').text(data.Message);
                                //$("#error-cap-email").html(data.Message);
                            }
                        }
                    }, "json");
                },
                minLength: 1,
                autoFocus: true,
                appendTo: '#Login-autocomplete',
                search: function (event, ui) {
                    zoneSaisie.removeClass("input-validation-error");
                    zoneSaisie.next('.field-validation-error').text('');
                    $("#error-cap-email").html('');
                },
                select: function (event, ui) {
                    event.preventDefault();

                    zoneSaisie.removeClass("input-validation-error");
                    zoneSaisie.next('.field-validation-error').text('');
                    $("#error-cap-email").html('');

                    zoneSaisie.val(ui.item.label);
                    zoneSaisie.focus();

                    $.post("/Espaceclient/CheckEmail", { email: zoneSaisie.val() }, async function (data) {
                        if (!data.IsValid) {

                            if (data.Message != null && data.Message.length > 0) {
                                zoneSaisie.addClass("input-validation-error");
                                zoneSaisie.next('.field-validation-error').text(await window.Foundation.libs.matyWeglot.adaptStringToLang(data.Message));
                                //$("#error-cap-email").html(data.Message);
                            }
                        }
                    }, "json");

                    //$("#Password").select();
                }
            });
            // }
        }
    }

    //click login : email vide
    $("#form-mire-saisie-mdp > button").on('click', function (e) {
        var origin = $(this).data('origin');

        $(document).foundation('mastertag', 'track_tc_event',
            {
                obj: this,
                trigger: "clic_type_identification",
                options: {
                    id: "login",
                    category: "connexion",
                    action: origin,
                    label: "mail",
                    value: ""
                }
            });
    });
});